import script from "./PullToRefresh.vue?vue&type=script&setup=true&lang=js"
export * from "./PullToRefresh.vue?vue&type=script&setup=true&lang=js"

import "./PullToRefresh.vue?vue&type=style&index=0&id=3b597642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b597642"]])

export default __exports__